import { SelectionType } from '@swimlane/ngx-datatable';

export class DatatableModel<T> {
    PageSize: number;
    TotalElements: number;
    TotalPages: number;
    CurrentPageNumber: number;
    SortBy: string;
    SortDir: string;
    ExternalPaging?: boolean;
    ExternalSorting?: boolean;
    FooterHeight?: boolean;
    LoadingIndicator?: boolean;
    ScrollbarH?: boolean;
    ScrollbarV?: boolean;
    SelectionType?: SelectionType;
    TrackByProp?: string;
    Data: Array<T>;
    OnActivateEventType?: Array<string>;
    rowClass?: any;
    constructor(defaultSortBy: string = 'Id', defaultSortDir: string = 'asc') {
        this.PageSize = 10;
        this.TotalElements = 0;
        this.TotalPages = 0;
        this.CurrentPageNumber = 0;
        this.Data = new Array<T>();
        this.OnActivateEventType = [];

        this.SortBy = defaultSortBy;
        this.SortDir = defaultSortDir;
    }
}
